import {ApDynGridPagerConfig, IDynGridWizardChoiceData} from '../../../ap-dyngrids/config/ap-dyn-grid-pager-config';
import {ApGridPagerType} from '../../../ap-interface/enums';
import {ApIcons}         from '../../../ap-interface/enums/layout/ap-icons';
import {EventEmitter}    from '@angular/core';

export class PagerBuilder {
  static PlanningBookingPager(options: {text: string, callback: EventEmitter<any>}[]): ApDynGridPagerConfig {
    return new ApDynGridPagerConfig({
      listMassEditing: options.map((option, index) =>
        ({
          id: index,
          name: option.text,
          type: ApGridPagerType.None,
          onSubmit: option.callback
        } as IDynGridWizardChoiceData)),
      iconButtons: [
        {icon: ApIcons.PDF, callback: undefined},
        {icon: ApIcons.XLS, callback: undefined},
      ]
    });
  }
}
